// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal overlay */
.upload-document-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal content */
.upload-document-modal-content {
  background: white;
  border-radius: 0.8rem;
  width: 90%;
  max-width: 60rem;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 0.4rem 0.6rem rgba(0, 0, 0, 0.1);
}

/* Modal header */
.upload-document-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-bottom: 0.1rem solid #E5E7EB;
}

.upload-document-modal-header h2 {
  margin: 0;
  color: #1A2634;
  font-size: 2rem;
  font-weight: 600;
}

.upload-document-modal-close {
  background: none;
  border: none;
  font-size: 3rem;
  color: #6B7280;
  cursor: pointer;
  padding: 0;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: color 0.2s;
}

.upload-document-modal-close:hover {
  color: #1A2634;
}

/* Form */
.upload-document-form {
  padding: 2rem;
}

.form-group {
  margin-bottom: 2rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.8rem;
  color: #1A2634;
  font-size: 1.4rem;
  font-weight: 500;
}

.form-group select,
.form-group input[type="file"],
.form-group textarea {
  width: 100%;
  padding: 1rem;
  border: 0.1rem solid #D1D5DB;
  border-radius: 0.4rem;
  font-size: 1.4rem;
  font-family: inherit;
  transition: border-color 0.2s;
}

.form-group select:focus,
.form-group input[type="file"]:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #ED7A2B;
}

.form-group select:disabled,
.form-group input[type="file"]:disabled,
.form-group textarea:disabled {
  background-color: #F3F4F6;
  cursor: not-allowed;
}

.form-group textarea {
  resize: vertical;
  min-height: 8rem;
}

.file-info {
  margin-top: 0.8rem;
  color: #6B7280;
  font-size: 1.2rem;
}

/* Error message */
.upload-error-message {
  background-color: #FEE2E2;
  color: #DC2626;
  padding: 1rem;
  border-radius: 0.4rem;
  margin-bottom: 2rem;
  font-size: 1.4rem;
}

/* Modal actions */
.upload-document-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 2rem;
  border-top: 0.1rem solid #E5E7EB;
}

/* Responsive */
@media (max-width: 768px) {
  .upload-document-modal-content {
    width: 95%;
    max-height: 95vh;
  }

  .upload-document-modal-header {
    padding: 1.5rem;
  }

  .upload-document-form {
    padding: 1.5rem;
  }

  .upload-document-modal-actions {
    flex-direction: column-reverse;
  }

  .upload-document-modal-actions button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composants/UploadDocumentModal/UploadDocumentModal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Modal overlay */\n.upload-document-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Modal content */\n.upload-document-modal-content {\n  background: white;\n  border-radius: 0.8rem;\n  width: 90%;\n  max-width: 60rem;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 0.4rem 0.6rem rgba(0, 0, 0, 0.1);\n}\n\n/* Modal header */\n.upload-document-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem;\n  border-bottom: 0.1rem solid #E5E7EB;\n}\n\n.upload-document-modal-header h2 {\n  margin: 0;\n  color: #1A2634;\n  font-size: 2rem;\n  font-weight: 600;\n}\n\n.upload-document-modal-close {\n  background: none;\n  border: none;\n  font-size: 3rem;\n  color: #6B7280;\n  cursor: pointer;\n  padding: 0;\n  width: 3rem;\n  height: 3rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  transition: color 0.2s;\n}\n\n.upload-document-modal-close:hover {\n  color: #1A2634;\n}\n\n/* Form */\n.upload-document-form {\n  padding: 2rem;\n}\n\n.form-group {\n  margin-bottom: 2rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.8rem;\n  color: #1A2634;\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n\n.form-group select,\n.form-group input[type=\"file\"],\n.form-group textarea {\n  width: 100%;\n  padding: 1rem;\n  border: 0.1rem solid #D1D5DB;\n  border-radius: 0.4rem;\n  font-size: 1.4rem;\n  font-family: inherit;\n  transition: border-color 0.2s;\n}\n\n.form-group select:focus,\n.form-group input[type=\"file\"]:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #ED7A2B;\n}\n\n.form-group select:disabled,\n.form-group input[type=\"file\"]:disabled,\n.form-group textarea:disabled {\n  background-color: #F3F4F6;\n  cursor: not-allowed;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 8rem;\n}\n\n.file-info {\n  margin-top: 0.8rem;\n  color: #6B7280;\n  font-size: 1.2rem;\n}\n\n/* Error message */\n.upload-error-message {\n  background-color: #FEE2E2;\n  color: #DC2626;\n  padding: 1rem;\n  border-radius: 0.4rem;\n  margin-bottom: 2rem;\n  font-size: 1.4rem;\n}\n\n/* Modal actions */\n.upload-document-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding-top: 2rem;\n  border-top: 0.1rem solid #E5E7EB;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .upload-document-modal-content {\n    width: 95%;\n    max-height: 95vh;\n  }\n\n  .upload-document-modal-header {\n    padding: 1.5rem;\n  }\n\n  .upload-document-form {\n    padding: 1.5rem;\n  }\n\n  .upload-document-modal-actions {\n    flex-direction: column-reverse;\n  }\n\n  .upload-document-modal-actions button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
